/* Huntington Sportswear — theme.js
   Plain ES5-safe JS, no dependencies. Every behaviour is bound by data-attribute
   so sections stay editable in the theme editor without touching this file. */
(function () {
  'use strict';
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- custom cursor ---------- */
  function cursor() {
    if (document.body.getAttribute('data-cursor') !== 'true') return;
    if (window.matchMedia('(pointer:coarse)').matches) return;
    var ring = $('[data-cursor-ring]'), dot = $('[data-cursor-dot]');
    if (!ring || !dot) return;
    var rx = 0, ry = 0, x = 0, y = 0, shown = false;
    document.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      dot.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%)';
      if (!shown) { shown = true; ring.style.display = 'block'; dot.style.display = 'block'; }
    });
    (function loop() {
      rx += (x - rx) * 0.18; ry += (y - ry) * 0.18;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
    document.addEventListener('mouseover', function (e) {
      var t = e.target.closest ? e.target.closest('a,button,[role=button]') : null;
      ring.classList.toggle('is-active', !!t);
    });
  }

  /* ---------- sticky header state ---------- */
  function header() {
    var h = $('[data-header]');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('is-stuck', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile menu ---------- */
  function menu() {
    var btn = $('[data-burger]'), nav = $('[data-mnav]');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    $$('a', nav).forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- horizontal carousels ---------- */
  function carousels() {
    $$('[data-carousel]').forEach(function (root) {
      var track = $('[data-track]', root);
      if (!track) return;
      var prev = $('[data-prev]', root), next = $('[data-next]', root);
      var step = function () {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 2 : 300;
      };
      var sync = function () {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft < 8;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- testimonial slider ---------- */
  function quotes() {
    $$('[data-quotes]').forEach(function (root) {
      var slides = $$('[data-quote]', root);
      var dots = $$('[data-dot]', root);
      if (slides.length < 2) return;
      var i = 0, timer;
      var show = function (n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.hidden = k !== i; });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); restart(); }); });
      var p = $('[data-qprev]', root), n = $('[data-qnext]', root);
      if (p) p.addEventListener('click', function () { show(i - 1); restart(); });
      if (n) n.addEventListener('click', function () { show(i + 1); restart(); });
      function restart() { clearInterval(timer); if (!reduced) timer = setInterval(function () { show(i + 1); }, 7000); }
      show(0); restart();
    });
  }

  /* ---------- accordions ---------- */
  function accordions() {
    $$('[data-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.classList.toggle('is-open', !open);
      });
    });
  }

  /* ---------- collection filters (client side, static build) ---------- */
  function filters() {
    $$('[data-filter-group]').forEach(function (group) {
      var targetSel = group.getAttribute('data-filter-target');
      var items = $$(targetSel + ' [data-sport]');
      $$('[data-filter]', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-filter');
          $$('[data-filter]', group).forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
          var shown = 0;
          items.forEach(function (el) {
            var hit = val === 'all' || el.getAttribute('data-sport') === val;
            el.hidden = !hit;
            if (hit) shown++;
          });
          var count = $('[data-filter-count]');
          if (count) count.textContent = shown + (shown === 1 ? ' product' : ' products');
          var empty = $('[data-filter-empty]');
          if (empty) empty.hidden = shown !== 0;
        });
      });
    });
  }

  /* ---------- product gallery ---------- */
  function gallery() {
    $$('[data-gallery]').forEach(function (root) {
      var main = $('[data-gallery-main]', root);
      $$('[data-gallery-thumb]', root).forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.getAttribute('data-src');
          var img = $('img', main);
          if (img && src) img.src = src;
          $$('[data-gallery-thumb]', root).forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- variant pickers (visual only in static build) ---------- */
  function pickers() {
    $$('[data-picker]').forEach(function (group) {
      $$('button', group).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('button', group).forEach(function (o) { o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
          var out = group.getAttribute('data-picker-output');
          if (out) { var el = $(out); if (el) el.textContent = b.getAttribute('data-value') || b.textContent.trim(); }
          var input = $('input[type=hidden]', group);
          if (input) input.value = b.getAttribute('data-value') || b.textContent.trim();
        });
      });
    });
  }

  /* ---------- quantity steppers ---------- */
  function qty() {
    $$('[data-qty]').forEach(function (root) {
      var input = $('input', root);
      if (!input) return;
      $$('[data-qty-step]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var d = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
          var v = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + d);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- file inputs ---------- */
  function files() {
    $$('[data-file]').forEach(function (wrap) {
      var input = $('input[type=file]', wrap), label = $('[data-file-label]', wrap);
      if (!input || !label) return;
      var base = label.textContent;
      input.addEventListener('change', function () {
        label.textContent = input.files && input.files.length
          ? (input.files.length === 1 ? input.files[0].name : input.files.length + ' files selected')
          : base;
      });
    });
  }

  /* ---------- forms: inline success state ----------
     Static build: no endpoint is wired. Swap the action / remove the
     preventDefault below once the backend or Shopify contact form is in place. */
  function forms() {
    $$('[data-form-wrap]').forEach(function (wrap) {
      var form = $('form', wrap);
      if (!form || form.getAttribute('data-live') === 'true') return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        wrap.classList.add('is-sent');
        wrap.scrollTop = 0;
      });
    });
  }

  /* ---------- newsletter ---------- */
  function news() {
    $$('[data-news]').forEach(function (wrap) {
      var form = $('form', wrap);
      if (!form || form.getAttribute('data-live') === 'true') return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        wrap.classList.add('is-done');
      });
    });
  }

  /* ---------- reveal on scroll ---------- */
  function reveal() {
    var els = $$('.reveal');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var d = parseFloat(en.target.getAttribute('data-reveal-delay') || '0');
        en.target.style.transitionDelay = d + 'ms';
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- animated stat counters ---------- */
  function counters() {
    var els = $$('[data-count]');
    if (!els.length) return;
    var format = function (n, compact) {
      if (compact && n >= 1000000) return (n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1) + 'M';
      if (compact && n >= 1000) return Math.round(n / 1000) + 'K';
      return Math.round(n).toLocaleString('en-US');
    };
    var run = function (el) {
      var target = parseFloat(el.getAttribute('data-count')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var compact = el.getAttribute('data-compact') === '1';
      if (reduced) { el.textContent = format(target, compact) + suffix; return; }
      var start = null, dur = 1600;
      var tick = function (t) {
        if (start === null) start = t;
        var p = Math.min(1, (t - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = format(target * eased, compact) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        run(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    cursor(); header(); menu(); carousels(); quotes(); accordions();
    filters(); gallery(); pickers(); qty(); files(); forms(); news(); reveal(); counters();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor hooks */
  document.addEventListener('shopify:section:load', init);
})();
